var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowGlyph = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m10.875 6.704 4.918-2.023c.912-.911.4-2.471-.874-2.663L8.837 1.09 1.795.019a1.573 1.573 0 0 0-1.793 1.79l1.074 7.032.927 6.074c.194 1.273 1.756 1.783 2.668.874l1.943-4.713 20.623 18.288c.732.728 1.797.849 2.379.27.58-.58.46-1.636-.272-2.364z"
})));
export default SvgArrowGlyph;